import { Component, signal, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { AuthService } from './core/services/auth';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('office-global-web');
  private router = inject(Router);
  private authService = inject(AuthService);
  private routerSubscription?: Subscription;

  ngOnInit(): void {
    // Subscribe to router events to scroll to top on route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.scrollToTop();
      });

    // The AuthService constructor automatically initializes token refresh
    // It handles expired tokens, starts periodic refresh, and sets up visibility handlers
    // No additional initialization needed here
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private scrollToTop(): void {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
      // Scroll to top of the page
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
}
